var React = require('react');

function IconCollapse (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","key":0},React.createElement("path",{"d":"M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32h320c17.7 0 32-14.3 32-32S369.7 0 352 0H32Zm182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4V416c0 17.7 14.3 32 32 32s32-14.3 32-32V237.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128h-.1Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h384v448H0z"})))]);
}

IconCollapse.defaultProps = {"fill":"currentColor","viewBox":"0 0 384 448"};

module.exports = IconCollapse;

IconCollapse.default = IconCollapse;
